import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { PAGE_PERMISSIONS, CRUD_PERMISSIONS } from "../constants/user";
import Icon from "./common/Icon";
import litigation from "../images/Litigation.png";
import GSTR9CIcon from "../images/gstr9c.png";
import Gstr3bIcon from "../images/gstr3b.png";
import GSTR9Icon from "../images/gstr9.png";
import RefundIcon from "../images/refunds.png";
import gstr1Icon from "../images/gstr1.png";
import StatementIcon from "../images/sbdata.png";
import ClientInfo from "../images/client.png";
import reconciliationIcon from "../images/RoDTEP-RoSCTL.png";
import scripReportIcon from "../images/scripreport.png";
import ebrcIcon from "../images/ebrc.png"

import Base from "./Base";
import useCheckAuthorization from "../hooks/checkAuthorization";
import ChatPopup from "./common/ChatPopup";
import CreateNewClient from "./clients/CreateNewClient";
import { getPeriods, resetStore } from "../slices/periodReducer";

import {
  updateClient,
  resetStore as clientResetStore,
  getSingleClient,
} from "../slices/clientReducer";
import {
  CREATE_CLIENT_SCHEMA,
  CREATE_CLIENT_FIELDS,
} from "../constants/clients";
import { useEffect, useState } from "react";
import { Alert, Col, Row, Breadcrumb } from "react-bootstrap";
import {
  getLitigation,
  resetLitigationState,
} from "../slices/litigationReducer";
import { truncateText } from "../utils";

function TaxForms() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data, loading, total_count, client: singleClient } =
    useSelector((state) => state.clients);
  const [current_page, setCurrentPage] = useState(1);
  //const { permissions } = useSelector((state) => state.common);
  const { client_id } = useParams();
  const [errors, setErrors] = useState({});
  //const [show, openModal] = useState(false)
  const [showClient, openClientModal] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  //const [updateData, setValues] = useState({});
  const { error, client, success, successMsg } = useSelector(
    (state) => state.periods
  );

  const {
    error: clientError,
    success: clientSuccess,
    successMsg: clientSuccessMsg,
  } = useSelector((state) => state.clients);
  const editClientPermission = useCheckAuthorization(
    CRUD_PERMISSIONS.client.edit
  );
  const hasPermission = useCheckAuthorization(PAGE_PERMISSIONS.client);

  const gstr1Click = () => {
    navigate(`/gstr-1/${client_id}`);
  };

  const refundsClick = () => {
    navigate(`/refunds/${client_id}`);
  };

  const statement3Click = () => {
    navigate(`/periods/${client_id}`);
  };

  const reconciliationClick = () => {
    navigate(`/RoDTEP/RoSCTL/${client_id}`);
  };
  const scripReportClick = () =>{
    navigate(`/scrip/report/${client_id}`)
  }
  const EbrcClick = () => {
    navigate(`/ebrc/${client_id}`);
  };

  const gstr3bClick = () => {
    navigate(`/gstr3b/${client_id}`);
  };

  const gstr9Click = () => {
    navigate(`/gstr9/${client_id}`);
  };

  const gstr9cClick = () => {
    navigate(`/gstr9c/${client_id}`);
  };

  const litigationClick = () => {
    navigate(`/litigation/${client_id}`);
  };

  const gstRepoClick = () => {
    navigate(`/gstrepo/${client_id}`);
  };

  // const hsnClick = () => {
  //   navigate(`/hsn/sac/${client_id}`);
  // };

  useEffect(() => {
    dispatch(getSingleClient(client_id));
    if (!hasPermission) {
      navigate("/authorization-error");
    }
    return () => {
      dispatch(resetStore("all"));
      dispatch(clientResetStore());
    };
  }, []);

  useEffect(() => {
    dispatch(getPeriods({ id: client_id, page_number: current_page }));
  }, [client_id]);

  useEffect(() => {
    if (showClient && client_id)
      dispatch(getPeriods({ id: client_id, page_number: current_page }));
  }, [client_id, showClient]);

  /*useEffect(()=>{
    if (period.id) {
        setIsUpdate(true) 
        setValues(period)
        openModal(true)
    }
  },[period]);*/

  const isCheckboxList = (element) => {
    return (
      element instanceof NodeList &&
      element.length > 0 &&
      element[0] instanceof HTMLInputElement &&
      element[0].type === "checkbox"
    );
  };

  const onClientSubmit = async (e, isUpdate) => {
    e.preventDefault();
    const values = {};
    Object.keys(CREATE_CLIENT_FIELDS).forEach((field) => {
      if (e.target[field].type === "checkbox") {
        // For checkboxes, use the `checked` property
        values[field] = e.target[field].checked;
      } else if (isCheckboxList(e.target[field])) {
        values[field] = Array.from(e.target[field])
          .filter((checkbox) => checkbox.checked)
          .map((checkbox) => checkbox.value);
      } else {
        values[field] = e.target[field].value;
      }
    });
    try {
      const data = await CREATE_CLIENT_SCHEMA.validate(values, {
        abortEarly: false,
      });
      if (data) {
        dispatch(updateClient({ data, page_number: 1, client_id: client.id }));
      }
      openClientModal(false);
      setErrors({});
      setIsUpdate(false);
    } catch (err) {
      const errData = [];
      err.inner.forEach((e) => {
        errData[e.path] = e.message;
        setErrors(errData);
      });
    }
  };

  const handleClientModalClose = () => {
    openClientModal(false);
    setIsUpdate(false);
    dispatch(resetStore());
  };

  return (
    <Base hideDatepicker={true}>
      <Row>
        <Col className="mr-auto text-center">
          <Breadcrumb>
            <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: "/" }}>
              Dashboard
            </Breadcrumb.Item>
            <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: "/clients" }}>
              Clients
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Tax-Forms</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <div className="flex flex-wrap gap-x-10 items-center">
        {useCheckAuthorization(PAGE_PERMISSIONS.client) && (
          <>
            <Icon
              title={truncateText(singleClient && singleClient.client_name, 20)}
              imageUrl={ClientInfo}
              onClickFunc={() => navigate(`/client-process/${singleClient.id}`)}
              className="v-icons"
            />
            {/* <Icon
              className="v-icons"
              title="GST Repository"
              imageUrl={LitigationIcon}
              onClickFunc={gstRepoClick}
            /> */}

            {/* <Icon
            className="v-icons"
            title="HSN/SAC"
            imageUrl={litigation}
            onClickFunc={hsnClick}
          /> */}
          </>
        )}
        {useCheckAuthorization(PAGE_PERMISSIONS.gstr3b) && (
          <Icon
              className="v-icons"
              title="GSTR 3B"
              imageUrl={Gstr3bIcon}
              onClickFunc={gstr3bClick}
            />
        )}
        {useCheckAuthorization(PAGE_PERMISSIONS.gstr9) && (
            <Icon
              className="v-icons"
              title="GSTR 9"
              imageUrl={GSTR9Icon}
              onClickFunc={gstr9Click}
            />
        )}
        {useCheckAuthorization(PAGE_PERMISSIONS.gstr9c) && (
            <Icon
              className="v-icons"
              title="GSTR 9C"
              imageUrl={GSTR9CIcon}
              onClickFunc={gstr9cClick}
            />
        )}
        {useCheckAuthorization(PAGE_PERMISSIONS.gstr1) && (
            <Icon
              className="v-icons"
              title="GSTR 1"
              imageUrl={gstr1Icon}
              onClickFunc={gstr1Click}
            />
        )}
        {useCheckAuthorization(PAGE_PERMISSIONS.refund) && (
            <Icon
              className="v-icons"
              title="Refunds"
              imageUrl={RefundIcon}
              onClickFunc={refundsClick}
            />
        )}
        {useCheckAuthorization(PAGE_PERMISSIONS.litigation) && (
            <Icon
              className="v-icons"
              title="Litigation"
              imageUrl={litigation}
              onClickFunc={litigationClick}
            />
        )}
        {useCheckAuthorization(PAGE_PERMISSIONS.period) && (
          <Icon
            className="v-icons rounded-full"
            title="SB Data"
            imageUrl={StatementIcon}
            onClickFunc={statement3Click}
          />
        )}
        {useCheckAuthorization(PAGE_PERMISSIONS.reconciliation) && (
          <Icon
            className="v-icons"
            title="RoDTEP / RoSCTL"
            imageUrl={reconciliationIcon}
            onClickFunc={reconciliationClick}
          />
        )}
        {useCheckAuthorization(PAGE_PERMISSIONS.reconciliation) && (
          <Icon
            className="v-icons"
            title="Scrip Report"
            imageUrl={scripReportIcon}
            onClickFunc={scripReportClick}
          />
        )}
        {useCheckAuthorization(PAGE_PERMISSIONS.reconciliation) && (
          <Icon
            className="v-icons"
            title="E-BRC"
            imageUrl={ebrcIcon}
            onClickFunc={EbrcClick}
          />
        )}
      </div>
      <ChatPopup client_id={client_id} chat_type="GENERAL" />
      <CreateNewClient
        fields={CREATE_CLIENT_FIELDS}
        handleSubmit={onClientSubmit}
        errors={errors}
        show={showClient}
        onHideFunc={handleClientModalClose}
        isUpdate={isUpdate}
        values={client || {}}
        editClientPermission={editClientPermission}
      />
    </Base>
  );
}

export default TaxForms;
